"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstDependencyDTO = void 0;
const enum_string_field_definition_1 = require("../../form_fields/enum_string_field_definition");
class ConstDependencyDTO {
    get values() {
        return this.parentField instanceof enum_string_field_definition_1.EnumStringFieldDefinition ? this.parentField.selectableOptions : [];
    }
    constructor(parentField, requiredValue, dependentFields) {
        this.parentField = parentField;
        this.requiredValue = requiredValue;
        this.dependentFields = dependentFields;
    }
}
exports.ConstDependencyDTO = ConstDependencyDTO;
